import { Screen } from '~/screens/clients/[id]/edit';

export const EditClient = () => {
  return <Screen />;
};
